import {Injectable} from '@angular/core';
import {MessageService} from 'primeng/api';

@Injectable({
  providedIn: "root"
})
export class ToastService {

  constructor(private messageService: MessageService) { }

  public showToast(
    message: string = 'Hubo un error, intenta de nuevo',
    type: string = 'error',
    summary: string = 'Error',
    key: string = "br"
  ){
    this.messageService.add({key, severity: type, summary, detail: message, life: 8000})
  }
}

